var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.625C8.76142 15.625 11 13.3864 11 10.625V9.375M6 15.625C3.23858 15.625 1 13.3864 1 10.625V9.375M6 15.625V18.75M2.875 18.75H9.125M6 13.125C4.61929 13.125 3.5 12.0057 3.5 10.625V3.75C3.5 2.36929 4.61929 1.25 6 1.25C7.38071 1.25 8.5 2.36929 8.5 3.75V10.625C8.5 12.0057 7.38071 13.125 6 13.125Z",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/microphone-icon.c6e87a15ae9061db801e4486efb88dcd.svg";
export { ForwardRef as ReactComponent };